import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable2 = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns2 = [
    {
      prop: 'id',
      label: i18n.t('common_words.id'),
      edit: false,
      minWidth: 50,
      sortable: true,
    },
    {
      prop: 'fecha',
      label: i18n.t('common_words.date'),
      edit: false,
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'hora',
      label: i18n.t('common_words.hour'),
      edit: false,
      minWidth: 100,
      sortable: true,
    },
    /*{
      prop: "code_finca",
      label: "Código de Finca",
      edit: false,
      minWidth: 120
    },
    {
      prop: "peso",
      label: "Peso Neto (Kg)",
      edit: false,
      minWidth: 120
    },
    {
      prop: "tipo_caja_id",
      label: "Caja",
      edit: false,
      minWidth: 120
    },*/
  ];

  return { Table };
};

export default configTable2;
